import qccapis  from "../../api/qcc";
import apis from "../../api/index";
import flowapis  from "../../api/flow";
import {dateUtils} from "../../utils/dateUtils";
import {utils} from "../../utils/utils";
import bankapis  from "../../api/bank";

export default {
    name: "LoanAudit",
    props: {
      visible: {
          type: Boolean, 
          require: false 
      },
      propsOne: String
    },
    data() {
        return {
            activeName:'first',
            activeNameZx:'first',
            scrollHeight:400,
            query: {
                userName: "",
            },
            isVisible:this.visible,
            detailResult:{},

            caseResult:["","","",""],
            dataShow:false,
            sxdataList:[],
            sxdata:[],
            sxtype:0,
            labelList:["失信被执行","被执行","严重违法","裁判文书"],
            AllData:[[],[],[],[]],
            pageIndex:1,
            pageSize:10,
            mlShow:false,

            llTableData:[],
            cllTableData:[],
            llListResult:[],
            llShow:false,
            cllShow:false,
            llquery:false,

            credit:{num:"暂无",comment:"暂无"},
            flowInfo:{},
            fileList:[],
            fileList_FJ:[],
            picList:[],
            reasonVisible:false,
            queryTime:dateUtils.dateToStr("yyyy-MM-dd hh:mm:00",new Date()),
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            businessShow:false,
            firstBusinessOption:['电商','种植','养殖','农产品加工','农资农机销售','农产品购销','农业服务','农业旅游农家乐','农业相关工程','其他'],
            xmlist:['肉牛','柑桔','粮食','蔬菜','牲猪','水产','羊','鸡','砂梨','农业服务','农业旅游','苗木','园林绿化工程','农家乐','农资','秸秆回收','青储','饲料','其他'],
            secondBusinessTitle: '二级分类',
            secondBusinessPlaceHolder: '输入对应主营项目的二级类目',

            loanApply:{
              ApplyID:'',
              UserId:'',
              Phone:'',
              PersonCompanyText:'',
              PersonCompanyFlag:'',
              PersonCompanyKey:'',
              LoanTipsId:'',
              Money:'',
              CreateTime:'',
              BankID:'',
              BankSiteID:'',
              SiteDirectorID:'',
              FirstBusiness:'',
              SecondBusiness:'',
              ThirdBusiness:[],
              PeopleCount:'',
              LastYearIncome:'',
              LastYearTax:'',
              LastYearProfit:'',
            },
            loanAudit:{
              Id:null,
              Business:null,
              BusinessDetail:null,
              RiskSharing:null,
              LoanCode:null,
              LoanRate:null,
              State:null,
              LoanMonth:null,
              FristInquirer:null,
              SecondInquirer:null,
              Category:null,
              CreditRating:null,
              TotalAssets:null,
              AssetCoverage:null,
              SaleProceeds:null,
              NetProfits:null,
              Ratal:null,
              LoanBalance:null,
              GuaranteeType:3,
              Guarantor:null,
              GuarantorCode:null,
              CustomProperty:null,
              CustomType:null,
              ReturnMoneyStatus:null,
              GuaranteeLetterTime:null,
              LoanEndTime:null,
              LoanMoney:null,
              EntrustedGuarantee:null,
              AccountManager:null,
              AccountManagerPhone:null,
              ProTypeName:null,
              Area:null,
              GuaranteeRate:null,
                PeopleCountAudit:'',
                LastYearIncomeAudit:'',
                LastYearTaxAudit:'',
                LastYearProfitAudit:'',
                WTDBHTH:'',
                YHDBHTH:'',
                xyzk_value5:null,
                xyzk_value4:null,
                xyzk_value3:null,
                xyzk_value2:null,
                xyzk_value1:null,
                hknl_value1:null,
                hknl_value2:null,
                dbcs_value1:null,
                dbcs_value2:1,
                hknl_value3:null,
            },
            loanMortgage:[],
            loanCredit:{
              Id:null,
              keyword:null,
              num:null,
              createTime:null,
              danwei:null,
              money:null,
              comment2:null,
              comment2_gm:null,
              comment2_xy:null,
              comment2_js:null,
              comment:null,
              comment_xy:null,
              comment_gm:null,
              comment_js:null
            },
            loanCreditArea:{
              Id:null,
              keyword:null,
              name:null,
              area:null,
            },
            scorelist:[0,0,0,0,0,0],
            zxbglist:[],
            khlx:[
                {
                    value:"家庭农场",
                    label:"家庭农场"
                },
                {
                    value:"合作社",
                    label:"合作社"
                },
              {
                value:"公司",
                label:"公司"
              },
              {
                  value:"种养大户",
                  label:"种养大户"
              },
                {
                    value:"个体户",
                    label:"个体户"
                }
            ],
            wjfx:[
                {
                    value:"正常贷款",
                    label:"正常贷款"
                },
                {
                    value:"关注贷款",
                    label:"关注贷款"
                },
                {
                    value:"次级贷款",
                    label:"次级贷款"
                },
                {
                    value:"可疑贷款",
                    label:"可疑贷款"
                },
                {
                    value:"损失贷款",
                    label:"损失贷款"
                }
            ],
          xyzk_list1:[{value:1,label:"无任何逾期"},
          {value:2, label:"轻微逾期，已结清"},
          {value:3, label:"多次逾期，无严重违约"},
          {value:4,label:"严重逾期或当前逾期"},
          {value:0,label:"无数据"},
        ],
        xyzk_list2:[{value:1,label:"近半年征信查询小于5次"},
          {value:2, label:"近半年征信贷款查询5-10次"},
          {value:3, label:"近半年征信贷款查询10次以上"},
          {value:0,label:"无数据"},
        ],
        xyzk_list3:[{value:1,label:"无诉讼记录"},
          {value:2, label:"已结案小额诉讼"},
          {value:3, label:"多未结案或大额诉讼"},
          {value:4,label:"频繁涉及诉讼"},
          {value:0,label:"无数据"},
        ],
        xyzk_list4:[{value:1,label:"已婚本地有房"},
          {value:2, label:"未婚本地有房"},
          {value:3, label:"已婚本地无房"},
          {value:4,label:"未婚本地无房"},
          {value:0,label:"无数据"},
        ],
        xyzk_list5:[{value:1,label:"经营稳定，盈利良好"},
          {value:2, label:"经营一般，盈利波动"},
          {value:3, label:"经营困难，当年亏损"},
          {value:4,label:"经营困难，连续亏损"},
          {value:0,label:"无数据"},
        ],
        hknl_list1:[{value:1,label:"资产负债率低"},
        {value:2, label:"资产负债率适中"},
        {value:3, label:"资产负债率偏高"},
        {value:4,label:"资产负债率过高"},
        {value:0,label:"无数据"},
        ],
        hknl_list2:[{value:1,label:"收入稳定，现金流充足"},
        {value:2, label:"收入一般，现金流尚可"},
        {value:3, label:"收入波动，现金流紧张"},
        {value:0,label:"无数据"},
        ],
        hknl_list3:[{value:1,label:"便于流通变现价值高于贷款金额"},
        {value:2, label:"便于流通变现价值低于贷款金额"},
        {value:3, label:"不便于流通变现"},
        {value:4, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:5, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:0,label:"无数据"},
        ],
        dbcs_list1:[{value:1,label:"信用优秀，担保能力强"},
        {value:2, label:"信用良好，担保能力适中"},
        {value:3, label:"信用一般，担保能力较弱"},
        {value:4,label:"信用较差，担保能力有限"},
        {value:5,label:"非有效担保人"},
        {value:0,label:"无数据"},
        ],
        dbcs_list2:[{value:1,label:"正式抵押+保证人"},
        {value:2, label:"正式抵押"},
        {value:3, label:"保证人"},
        {value:4, label:"无保证人或抵押物"},
        {value:0,label:"无数据"},
        ],
            khxz:[
              {
                  value:"新增",
                  label:"新增"
              },
              {
                  value:"续贷",
                  label:"续贷"
              },
              {
                  value:"展期",
                  label:"展期"
              }
            ],
            hkzt:[
              {
                  value:1,
                  label:"结清"
              },
              {
                  value:2,
                  label:"逾期"
              },
              {
                  value:3,
                  label:"代偿"
              }
            ],
            dialogVisible2:false,
            dyType:'',
            dyTypes:[],
            dyTypes2:[
              {
                  value:-1,
                  label:"保证人"
              }
            ],
            dyTypes3:[
              {
                  value:-1,
                  label:"保证人"
              },
              {
                  value:0,
                  label:"不动产"
              },
              {
                  value:1,
                  label:"设备"
              },
              {
                  value:2,
                  label:"水域滩涂"
              },
              {
                  value:3,
                  label:"农村承包土地"
              },
              {
                  value:4,
                  label:"股权"
              },
              {
                  value:5,
                  label:"其他"
              }
            ],
            dyTypes4:[
              {
                  value:0,
                  label:"不动产"
              },
              {
                  value:1,
                  label:"设备"
              },
              {
                  value:2,
                  label:"水域滩涂"
              },
              {
                  value:3,
                  label:"农村承包土地"
              },
              {
                  value:4,
                  label:"股权"
              },
              {
                  value:5,
                  label:"其他"
              }
            ],
            proTypeList:[],
            bankInfoObj:{},
            areaList:[],
            myInterval:null,
            rules_loanAudit: {
              Area:[
                  { required: true, message: '请选择区域', trigger: 'change' }
              ],
              CustomType:[
                { required: true, message: '请选择客户类型', trigger: 'change' }
              ],
              CustomProperty:[
                { required: true, message: '请选择客户性质', trigger: 'change' }
              ],
              ProTypeName:[
                { required: true, message: '请选择项目类别', trigger: 'change' }
              ],
              RiskSharing:[
                { required: true, message: '请填写项目风险比例(%)', trigger: 'change' }
              ],
              LoanMonth:[
                { required: true, message: '请填写担保期限(月)', trigger: 'change' }
              ],
              LoanEndTime:[
                { required: true, message: '请选择到期时间', trigger: 'change' }
              ],
              LoanCode:[
                { required: true, message: '请填写贷款合同号', trigger: 'change' }
              ],
              GuaranteeRate:[
                { required: true, message: '请填写担保费率(%)', trigger: 'change' }
              ],
              LoanMoney:[
                { required: true, message: '请填写担保费(元)', trigger: 'change' }
              ],
              LoanRate:[
                { required: true, message: '请填写借款利率', trigger: 'change' }
              ],
              Category:[
                { required: true, message: '请选择五级分类', trigger: 'change' }
              ],
              hknl_value3:[
                { required: true, message: '请选择抵押物价值', trigger: 'change' }
              ],
              FristInquirer:[
                { required: true, message: '请填写主调', trigger: 'change' }
              ],
              SecondInquirer:[
                { required: true, message: '请填写副调', trigger: 'change' }
              ],
              WTDBHTH:[
                { required: true, message: '请填写合同号', trigger: 'change' }
              ],
              YHDBHTH:[
                { required: true, message: '请填写合同号', trigger: 'change' }
              ],
              xyzk_value1:[
                { required: true, message: '请选择征信记录'}
            ],
            xyzk_value2:[
              { required: true, message: '请选择征信查询',trigger: 'change'}
          ],
          xyzk_value3:[
            { required: true, message: '请选择诉讼及执行情况',trigger: 'change'}
         ],
         xyzk_value4:[
          { required: true, message: '请选择借款人稳定性',trigger: 'change'}
          ],
         xyzk_value5:[
          { required: true, message: '请选择企业经营情况',trigger: 'change'}
          ],
            hknl_value2:[
              { required: true, message: '收入及现金流',trigger: 'change'}
              ],
              hknl_value3:[
                { required: true, message: '请选择抵押物价值',trigger: 'change'}
                ],
                dbcs_value1:[
                  { required: true, message: '请选择担保人信用及能力',trigger: 'change'}
                  ],
                  dbcs_value2:[
                    { required: true, message: '担保方式及风险',trigger: 'change'}
                    ],
            },
            rules_loanApply:{
              Money:[
                { required: true, message: '请填写贷款金额(万元)', trigger: 'change' }
              ],
              
            },
            bankList:[]
        };
    },
    beforeCreate: function () {
        let meta = this.$route.meta
        if(meta&&meta.permBtns.length>0){
          this.permBtns = meta.permBtns
        }
    },
    created() {
      this.getBankList();
    },
    activated() {
      // let that = this
      
    },
    deactivated(){
      let that = this
      if(that.myInterval){
          clearInterval(that.myInterval)
          that.myInterval = null
      }
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    methods: {
      getBankList(){
        let param= {
          keyword: "",
          pageIndex: 0,
          pageSize: 0
         };
        bankapis.getBankList(param).then(res => {
         this.bankList=res.list
         })
      },
      onGetScore(){
        var data=this.loanAudit;
        var list=[
          [0,100,90,60,0],
          [0,100,70,0],
          [0,100,90,60,40],
          [0,100,80,70,0],
          [0,100,80,70,20],
          [0,100,90,80,60],
          [0,100,80,30],
          [0,100,90,70,60,40],
          [0,100,90,60,30,10],
          [0,100,80,70,0],
        ]
        var qzlist=[10,5,10,5,10,10,5,10,15,20];
        var datalist=[0,0,0,0,0,0,0,0,0,0];
        datalist[0]=data.xyzk_value1?data.xyzk_value1:0;
        datalist[1]=data.xyzk_value2?data.xyzk_value2:0;
        datalist[2]=data.xyzk_value3?data.xyzk_value3:0;
        datalist[3]=data.xyzk_value4?data.xyzk_value4:0;
        datalist[4]=data.xyzk_value5?data.xyzk_value5:0;
        datalist[5]=data.hknl_value1?data.hknl_value1:0;
        datalist[6]=data.hknl_value2?data.hknl_value2:0;
        datalist[7]=data.hknl_value3?data.hknl_value3:0;
        datalist[8]=data.dbcs_value1?data.dbcs_value1:0;
        datalist[9]=data.dbcs_value2?data.dbcs_value2:0;
        var scorelist=[0,0,0,0,0,0];
        scorelist[0]=list[0][datalist[0]]*qzlist[0]+list[1][datalist[1]]*qzlist[1]+
        list[2][datalist[2]]*qzlist[2]+list[3][datalist[3]]*qzlist[3]+list[4][datalist[4]]*qzlist[4];
        scorelist[1]=list[5][datalist[5]]*qzlist[5]+list[6][datalist[6]]*qzlist[6]+list[7][datalist[7]]*qzlist[7]
        scorelist[2]=list[8][datalist[8]]*qzlist[8]+list[9][datalist[9]]*qzlist[9]
        if(data.LastYearTax>100)scorelist[3]+=500;
        scorelist[4]=scorelist[0]+scorelist[1]+scorelist[2]+scorelist[3]
        for(var i=0;i<5;i++){
          scorelist[i]=scorelist[i]*0.01;
        }
       if(data.AssetCoverage!=""&&data.TotalAssets!=""){
            var value=Number(data.TotalAssets)*
            (65-Number(data.AssetCoverage))*scorelist[4]*0.0001;
            if(value>0){
              var max=100;
              if(data.CustomType=="家庭农场")max=200;
              else if(data.CustomType=="合作社"||data.CustomType=="公司")max=500;
              value=value>max?max:value;
              scorelist[5]=value.toFixed(2);
            }
        }
        this.scorelist=scorelist;
        
      },
      onDbqxChange(){
        let that = this
        let now = new Date()
        let givenMonth = now.getMonth()
        let newMonth = givenMonth + parseInt(that.loanAudit.LoanMonth) 
        now.setMonth(newMonth)
        that.loanAudit.LoanEndTime = now
        that.setDbInfo()
      },
      showInput(){
        switch(this.loanAudit.GuaranteeType){
          case 2:
            this.dyTypes = this.dyTypes2
            break;
          case 3:
            this.dyTypes = this.dyTypes3
            break;
          case 4:
            this.dyTypes = this.dyTypes4
            break;
        }
        this.dialogVisible2 = true
      },
      showZxbgInput(){
        var item={
          name:"",money:"",bzfs:"",islate:"",month:"",
        }
        this.zxbglist.push(item)
      },
      handleClose(){
        this.dialogVisible2 = false
      },
      onAddItemChange(){
        let item= this.getEmptyMortgage()
        item.Type = this.dyType
        this.loanMortgage.push(item)
        this.dialogVisible2 = false
      },
      onRemoveTypeChange(index){
        this.loanMortgage.splice(index, 1)
      },
      onRemoveZxbgChange(index){
        this.zxbglist.splice(index, 1)
      },
      loanTypeChange(){
        var type=Number(this.loanAudit.GuaranteeType);
        if(type==1)this.loanAudit.dbcs_value2=4;
        else if(type==2)this.loanAudit.dbcs_value2=3;
        else if(type==3)this.loanAudit.dbcs_value2=1;
        else if(type==4)this.loanAudit.dbcs_value2=2;
        this.onGetScore()
      },
      changeAssetCoverage(){
        if(this.loanAudit.AssetCoverage){
        var num=Number(this.loanAudit.AssetCoverage)
        if(num<30)this.loanAudit.hknl_value1=1;
        else if(num>=30&&num<40)this.loanAudit.hknl_value1=2;
        else if(num>=40&&num<50)this.loanAudit.hknl_value1=3;
        else if(num>=50)this.loanAudit.hknl_value1=4;
      }
      else {
        this.loanAudit.hknl_value1="";
      }
        this.changeHknl2();
        this.onGetScore()
      },
      changeHknl2(){
        if(!this.loanAudit.LastYearIncomeAudit)return
        if(!this.loanAudit.TotalAssets)return
        if(!this.loanAudit.AssetCoverage)return
        var num1=Number(this.loanAudit.LastYearIncomeAudit)
        var num2=Number(this.loanAudit.TotalAssets)
        var num3=Number(this.loanAudit.AssetCoverage)
        var num4=num2*num3/100;
        if(num1<=num4)this.loanAudit.hknl_value2=3;
        else if(num1>num4&&num1<num4*2)this.loanAudit.hknl_value2=2;
        else if(num1>=num4*2)this.loanAudit.hknl_value2=1;
        this.onGetScore()
      },
      proTypeChange(){
        let that = this
        that.setDbInfo2()
      },
      onDBFLChange(){
        let that = this
        that.setDbInfo()
      },
      onChangeClose(){
        let that = this
        this.isVisible = false
        if(this.myInterval){
          window.clearTimeout(that.myInterval)
          this.myInterval = null
          // this.removeSaveItem()
        }
      },
      onChangeOpen(){
        this.isVisible = true
      },
      queryClick(flag){
        this.dataShow=true;
        this.sxtype=flag;
        if(this.caseResult[flag]>10)this.mlShow=true;
        else this.mlShow=false;
        this.pageIndex=1;
        this.sxdataList=this.getlistten(this.AllData[flag],1,10);
      },
      getlistten(list,pageIndex,pageSize){
        var newlist=[]
        for(var i=0;i<pageSize;i++){
          var j=i+(pageIndex-1)*pageSize;
          if(j<list.length)newlist.push(list[j]);
        }
        return newlist;
      },
      getList(flag){
        var type=this.sxtype;
        var that=this;
        var pageIndex=this.pageIndex+flag;
        if(pageIndex<1){that.$message.info("已经是第一页");return;}
        var allPage=(this.caseResult[this.sxtype]+9)/10;
        if(pageIndex>allPage){that.$message.info("已经是最后一页");return;};
        if(this.sxtype==2){
          this.pageIndex=pageIndex;
          this.sxdataList=this.getlistten(this.AllData[type],pageIndex,10);
        }else{
          let param1 = {
              id:that.flowInfo.Code,
              pageIndex:Math.ceil(pageIndex/2),
              type:Number(type)+1
           }
           
           qccapis.getCPCaseByType(param1).then(res => {
          if(res!=null){
            if(Number(res.Status)==200){
                var datalist=res.Result.Data;
                if(type==3){
                  for(var j=0;j<datalist.length;j++){
                    var roletype="";
                    if(datalist[j].IsProsecutor)roletype="原告";
                    if(datalist[j].IsDefendant)roletype="被告";
                    datalist[j].RoleType=roletype;
                    var partylist=datalist[j].PartyList;
                    for(var k=0;k<partylist.length;k++){
                       if(partylist[k].RoleType==roletype){
                        datalist[j].Statement=partylist[k].Statement
                       }
                    }
                  }
                }
                var danwei=pageIndex%2;
                if(danwei==0)danwei=2;
                that.pageIndex=pageIndex;
                var list=that.getlistten(res.Result.Data,danwei,10);
                that.sxdataList=list;
              }else{
               that.$message.error(res[i].Message)
              }
            }else{
             that.$message.error("查询信息失败")
           }
            });


        }
      },



      queryData(row){
        let that = this
        this.scorelist=[0,0,0,0,0,0]
        this.zxbglist=[]
        
        this.dataShow=false;
        this.sxdata=[];
        if(row){
          that.flowInfo = utils.deepCopy(row)

          if(that.flowInfo.PersonFlag===1){
            that.activeNameZx = 'second'
          }else{
            that.activeNameZx = 'first'
          }

          // 查询营业执照
          const yyzz = qccapis.getCPDetail({id:row.Code})
          // 诉讼信息
          const ssxx = qccapis.getCPCase({id:row.Code})
          // 查询老赖信息
          const llxx = qccapis.getLL({idCard:row.IdCard})
          // 查询老赖信息
          const llxx2 = qccapis.getLL({idCard:row.Code})

          // 查询审核信息 
          const shxx = flowapis.getLoanAuditInfo({
             applyId:that.flowInfo.ApplyID,
             auditId:that.flowInfo.AuditID,
             IdCard:that.flowInfo.IdCard
            }
          )
          
          const fileInfo = flowapis.getLoanFiles({processId:that.flowInfo.Id,type:'2',uploadType:'2'})

          // // 查询政务信息
          // const promise3 = 
          var itemStore=null;
          Promise.all([yyzz, ssxx , llxx,llxx2,shxx,fileInfo]).then((res) => {
            if(res.length===6){
              if(res[0]&&res[0]['Result']){
                that.detailResult = res[0]['Result']
              }else{
                that.detailResult = {}
              }
               if(res[2]){
                that.llTableData=res[2].list;
               }
              if(res[4]){
                if(res[4].applyObj){
                  that.loanApply = res[4].applyObj
                }else{
                   itemStore = that.getSaveItems('loanApply')
                  if(itemStore){
                    that.loanApply = itemStore
                  }else{
                    that.setEmptyApply()
                  }
                }
                if(res[4].areaList){
                  that.areaList = res[4].areaList
                }else{
                   itemStore = that.getSaveItems('loanApply');
                  if(itemStore){
                    that.loanApply = itemStore
                    that.changeHknl2()
                  }else{
                    that.setEmptyApply()
                  }
                }
                
                if(res[4].auditObj){
                  that.loanAudit = res[4].auditObj
                  if(that.loanAudit.GuaranteeLetterTime){
                    that.loanAudit.GuaranteeLetterTime = new Date(that.loanAudit.GuaranteeLetterTime)
                  }
                  if(that.loanAudit.LoanEndTime){
                    that.loanAudit.LoanEndTime= new Date(that.loanAudit.LoanEndTime)
                  }
                  if(that.loanAudit.GuaranteeType){
                     that.loanTypeChange()
                  }
                  if(that.loanAudit.ThirdBusiness){
                    that.loanAudit.ThirdBusiness=that.loanAudit.ThirdBusiness.toString().split(",");
                  }else{
                    that.loanAudit.BusinessDetail=that.loanApply.SecondBusiness
                    that.loanAudit.Business=that.loanApply.FirstBusiness
                    that.loanAudit.ThirdBusiness=that.loanApply.ThirdBusiness==null?[]:that.loanApply.ThirdBusiness.toString().split(",");
                  }
                  that.changeSecond()
                }else{
                   itemStore = that.getSaveItems('loanAudit')
                  if(itemStore){
                    that.loanAudit = itemStore
                  }else{
                    that.setEmptyAudit()
                      that.loanAudit.LastYearIncomeAudit = that.loanApply.LastYearIncome;
                      that.loanAudit.LastYearProfitAudit = that.loanApply.LastYearProfit;
                      that.loanAudit.LastYearTaxAudit = that.loanApply.LastYearTax;
                      that.loanAudit.PeopleCountAudit = that.loanApply.PeopleCount;
                      that.loanAudit.BusinessDetail=that.loanApply.SecondBusiness
                      that.loanAudit.Business=that.loanApply.FirstBusiness
                      that.loanAudit.ThirdBusiness=that.loanApply.ThirdBusiness==null?[]:that.loanApply.ThirdBusiness.toString().split(",");
                      that.changeSecond()
                      that.changeHknl2()
                  }
                }

                if(res[4].mortgageObj){
                  that.loanMortgage = res[4].mortgageObj
                }else{
                   itemStore = that.getSaveItems('loanMortgage')
                  if(itemStore){
                    that.loanMortgage = itemStore
                  }else{
                    that.loanMortgage = []
                  }
                }

                if(res[4].proTypeList){
                  that.proTypeList = res[4].proTypeList
                  if(that.loanAudit.GuaranteeRate){
                    that.setDbInfo()
                  }else{
                    that.setDbInfo2()
                  }
                }else{
                  that.proTypeList = []
                }
                if(res[4].bankInfoObj){
                  that.bankInfoObj = res[4].bankInfoObj
                }else{
                  that.bankInfoObj = {}
                }
                if(res[4].loanCreditObj){
                  that.loanCredit = res[4].loanCreditObj
                   itemStore = that.getSaveItems('loanCredit')
                  if(itemStore){
                    that.loanCredit = itemStore
                  }
                }else{
                   itemStore = that.getSaveItems('loanCredit')
                  if(itemStore){
                    that.loanCredit = itemStore
                  }else{
                    that.setEmptyCredit()
                  }
                }
                 itemStore = that.getSaveItems('zxbglist')
                if(itemStore){
                  that.zxbglist = itemStore
                }else{
                  that.zxbglist=[]
                }
                if(res[4].loanCreditAreaObj){
                  that.loanCreditArea = res[4].loanCreditAreaObj
                }else{
                  that.setEmptyCreditArea()
                }
              }else{
                that.setEmptyApply()
                that.setEmptyAudit()
                that.loanMortgage = []
                that.setEmptyCredit()
                that.setEmptyCreditArea()
              }
              if(res[5]&&res[5].length>0){
                that.fileList_FJ = []
                for(let f=0;f<res[5].length;f++){
                  that.fileList_FJ.push({
                    name:res[5][f]['Name'],
                    url:res[5][f]['Url']
                  })
                }
              }else{
                itemStore = that.getSaveItems('fileList_FJ')
                if(itemStore){
                  that.fileList_FJ = itemStore
                }else{
                  that.fileList_FJ=[]
                }
              }
              
              var qccres=res[1];
              if(qccres){
                that.sxdata=res;
              for(var i=0;i<4;i++){
                  if(Number(qccres[i].Status)==200){
                    if(qccres[i].Result.VerifyResult==0)that.caseResult[i]=0;
                    else {
                      if(i<2)that.caseResult[i] = qccres[i].Paging.TotalRecords;
                      if(i==2)that.caseResult[i]=qccres[i].Result.Data.length;
                      if(i==3){
                        that.caseResult[i] = qccres[i].Paging.TotalRecords;
                       var datalist=qccres[3].Result.Data;
                        for(var j=0;j<datalist.length;j++){
                          var roletype="";
                          if(datalist[j].IsProsecutor)roletype="原告";
                          if(datalist[j].IsDefendant)roletype="被告";
                          datalist[j].RoleType=roletype;
                          var partylist=datalist[j].PartyList;
                          for(var k=0;k<partylist.length;k++){
                             if(partylist[k].RoleType==roletype){
                              datalist[j].Statement=partylist[k].Statement
                             }
                          }
                        }
                      }
                      that.AllData[i]=that.AllData[i].concat(qccres[i].Result.Data);
                      if(!that.dataShow){
                           that.dataShow=true;
                           that.sxtype=i;
                           that.sxdataList=that.getlistten(qccres[i].Result.Data,1,10);
                           if(that.caseResult[i]>10)that.mlShow=true;
                      }

                    }
                }else{
                  that.caseResult[i]="";
                }
               }
               for(var i=0;i<4;i++){
                if(Number(qccres[i].Status)!=200){
                  that.$message.error("查询公司诉讼信息失败");that.loanAudit.xyzk_value3=0;that.onGetScore();return;
                 }
                }
                if(qccres[3].Paging&&qccres[3].Paging.TotalRecords>20){that.loanAudit.xyzk_value3=4;that.onGetScore();return;}
                if(qccres[0].Result.VerifyResult!=0){that.loanAudit.xyzk_value3=3;that.onGetScore();return;}
                if(qccres[1].Result.VerifyResult!=0){that.loanAudit.xyzk_value3=3;that.onGetScore();return;}
                if(qccres[2].Result.VerifyResult!=0){that.loanAudit.xyzk_value3=3;that.onGetScore();return;}
                 var datalist=qccres[3].Result.Data;
                  if(datalist)
                  for(var j=0;j<datalist.length;j++){
                    if(datalist[j].Amount>100000){
                          that.loanAudit.xyzk_value3=3;that.onGetScore();return;
                        }
                   }
                if(qccres[3].Result.VerifyResult!=0){that.loanAudit.xyzk_value3=2;that.onGetScore();return;}
                 that.loanAudit.xyzk_value3=1;that.onGetScore();
              }
            }
            that.timeOutSave()
          })
        }
      },
      beforeAvatarPicUpload(file) {
          let that = this
          const isJPG = 
              file.type ==="image/jpg"||
              file.type ==="image/jpeg"||
              file.type ==="image/png"
          const isLt2M = file.size/1024/1024 <2
          if(!isJPG){
              that.$message.error("仅支持jpg、png格式的图片")
          }
          if(!isLt2M){
              that.$message.error("上传图片大小不能超过2MB") 
          }
          return isJPG && isLt2M
      },
      uploadPicFile(item){
          let that = this
          let fileObj = item.file
          const form = new FormData()
          form.append("file",fileObj)
          apis.uploadFile(form).then(res => {
              that.picList.push({
                name: that.getFileName(res.fullPath),
                url:res.fullPath
              })
          });
      },
      beforeAvatarFileUpload(file) {
        let that = this
        const isLt2M = file.size/1024/1024 <10
        if(!isLt2M){
            that.$message.error("上传文件大小不能超过10MB") 
            return false 
        }
        return true
      },
      uploadFileFile(item){
          let that = this
          let fileObj = item.file
          const form = new FormData()
          form.append("file",fileObj)
          apis.uploadFile(form).then(res => {
              that.fileList.push({
                name: that.getFileName(res.fullPath),
                url:res.fullPath
              })
          });
      },
      uploadFileFile_FJ(item){
        let that = this
        let fileObj = item.file
        const form = new FormData()
        form.append("file",fileObj)
        apis.uploadFile(form).then(res => {
            that.fileList_FJ.push({
              name: that.getFileName(res.fullPath),
              url:res.fullPath
            })
        });
      },
      getFileName(path){
        var pos1 = path.lastIndexOf('/');
        var pos2 = path.lastIndexOf('\\');
        var pos  = Math.max(pos1, pos2)
        if( pos<0 )
            return path;
        else
            return path.substring(pos+1);
      },
      handlePicRemove(file) {
        let that = this
        if(file){
          for(let i=0;i<that.picList.length;i++){
            if(file.url===that.picList[i].url){
              that.picList.splice(i,1)
            }
          }
        }
      },
      handleFileRemove(file) {
        let that = this
        if(file){
          for(let i=0;i<that.fileList.length;i++){
            if(file.url===that.fileList[i].url){
              that.fileList.splice(i,1)
            }
          }
        }
      },
      handleFileRemove_FJ(file) {
        let that = this
        if(file){
          for(let i=0;i<that.fileList_FJ.length;i++){
            if(file.url===that.fileList_FJ[i].url){
              that.fileList_FJ.splice(i,1)
            }
          }
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handlePicDownload(file) {
        if(file){
          const blob = new Blob([file.url],{type:'application/vnd.ms-excel'})
          const elink = document.createElement('a')
          elink.download = file.name
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
      },

      /**
       * 保存文件
       */
      saveFjFileInfo(callback){
        let that = this
        let filesLists = []
        console.log(that.fileList_FJ.length)
        for(var i=0;i<that.fileList_FJ.length;i++){
          console.log(i)
          let fileInfo = {
            ProcessId:that.flowInfo.Id,
            Type:'2',
            Url:that.fileList_FJ[i]['url'],
            Name:that.fileList_FJ[i]['name'],
            UploadType:2
          }
          filesLists.push(fileInfo)
        }
        if(filesLists.length>0){
          flowapis.addLoanFile({fileList:filesLists}).then(res => {
            callback(res)
          })
        }else{
            callback(true)
        }
      },

      /**
       * 暂存在本地缓存中
       */
      onSaveLocalStore(){
        let that = this
        that.dynamicSaveItems()
      },

      /**
       * 银行拒绝
       * 
       */
      onReturnFlow(){
        let that = this
        this.$prompt('', '必须填写拒绝的原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '必须填写原因',
          inputValidator:(value)=>{
            if(value.trim().length<1){
              return false
            }
          },
          beforeClose: (action, instance, done)=>{
            if(action == 'confirm'){
                let value = instance.inputValue
                if(value && value != ''){
                  let flowParam = {
                    Id:that.flowInfo.Id,
                    Route:6,
                    RefuseReason:value,
                    State:'4',
                    RefuseType:'3'
                  }
                  
                  let loanAuditPara = utils.deepCopy(that.loanAudit);
                  if(that.loanAudit.GuaranteeLetterTime && JSON.stringify(that.loanAudit.GuaranteeLetterTime) !== '{}'){
                    if(!isNaN(Date.parse(that.loanAudit.GuaranteeLetterTime))){
                      that.loanAudit.GuaranteeLetterTime = new Date(that.loanAudit.GuaranteeLetterTime)
                    }
                    loanAuditPara.GuaranteeLetterTime = dateUtils.dateToStr("yyyy-MM-dd 00:00:00",that.loanAudit.GuaranteeLetterTime)
                  }else{
                    loanAuditPara.GuaranteeLetterTime = null;
                  }

                  if(that.loanAudit.LoanEndTime && JSON.stringify(that.loanAudit.LoanEndTime) !== '{}'){
                    if(!isNaN(Date.parse(that.loanAudit.LoanEndTime))){
                      that.loanAudit.LoanEndTime = new Date(that.loanAudit.LoanEndTime)
                    }
                    loanAuditPara.LoanEndTime = dateUtils.dateToStr("yyyy-MM-dd 00:00:00",that.loanAudit.LoanEndTime)
                  }else{
                    loanAuditPara.LoanEndTime = null;
                  }

                  that.loanCredit.keyword = that.loanApply.PersonCompanyKey
                  that.loanCredit.num = that.loanApply.Money
                  that.loanCredit.danwei= that.loanApply.PersonCompanyText
          
                  that.loanCreditArea.keyword = that.loanApply.PersonCompanyKey
                  that.loanCreditArea.name = that.flowInfo.Name

                  if(loanAuditPara.LoanMoney){
                    loanAuditPara.LoanMoney = utils.deepCopy(loanAuditPara.LoanMoney)*100
                  }
                  if(loanAuditPara.LoanMoney){
                    flowParam.GuaranteeFee = utils.deepCopy(loanAuditPara.LoanMoney)*100
                  }
                  var loanMortgage=that.loanMortgage;
                  if(loanAuditPara.GuaranteeType==2){
                    if(loanMortgage.length>0){
                        for(var i=loanMortgage.length-1;i>=0;i--){
                          if(loanMortgage[i].Type!=-1){
                            loanMortgage.splice(i,1)
                          }
                        }
                    }
                  }
                else if(loanAuditPara.GuaranteeType==4){
                  if(loanMortgage.length>0){
                    for(var i=loanMortgage.length-1;i>=0;i--){
                      if(loanMortgage[i].Type==-1){
                        loanMortgage.splice(i,1)
                      }
                    }
                   }
                  }
                  let param = {
                    loanAudit:that.setObjEmptyToNull(loanAuditPara),
                    loanMortgage:that.loanMortgage,
                    flowInfo:that.setObjEmptyToNull(flowParam),
                    loanCredit:that.setObjEmptyToNull(that.loanCredit),
                    loanCreditArea:that.setObjEmptyToNull(that.loanCreditArea)
                  }

                  flowapis.saveAuditInfo(param).then((res) => {
                    if(res){
                      done()
                    }else{
                      this.$message({
                        message: '拒绝失败请重试',
                        type: "error"
                      });
                    }
                  })
                }
            }else{
              done()
            }
          }
        }).then(({ value }) => {
            // that.$emit('bankauditsucess');
            if(that.myInterval){
                window.clearTimeout(that.myInterval)
                that.myInterval = null
            }
            that.removeSaveItem()
            that.onChangeClose()
            this.$parent.bankAuditSucess();
        }).catch(() => {
               
        });
      },

      setObjEmptyToNull(obj){
        Object.keys(obj).forEach(function(key, index) {
          if (this[key] === '') this[key] = null;
        }, obj);
        return obj
      },

      /**
       * 审核通过
       */
      onPassFlow(){
        let that = this
        var zblist=this.zxbglist;
        for(var i=0;i<zblist.length;i++){
       if(zblist[i].name==""||zblist[i].money==""||
       zblist[i].islate==""||zblist[i].bzfs==""){
  this.$message({
    message: '请检查信用报告',
    type: 'warning'
  });
  return
  }
  if(zblist[i].name=="其他")zblist[i].name=zblist[i].name2
    }
    if(this.loanAudit.ThirdBusiness.length==0){
      this.$message.error("请您选择二级业务")
      return
  }
  if(this.businessShow&&this.loanAudit.BusinessDetail==""){
      this.$message.error("请您输入业务说明")
      return
  }
        // //项目区域、类别、担保期限、担保费必填
        // if(!that.loanAudit.Area){
        //   this.$message({
        //     message: '请选择区域',
        //     type: 'warning'
        //   });
        //   return
        // }

        // //项目类别、担保期限、担保费必填
        // if(!that.loanAudit.ProTypeName){
        //   this.$message({
        //     message: '请选择项目类别',
        //     type: 'warning'
        //   });
        //   return
        // }
        // if(!that.loanAudit.LoanMonth){
        //   this.$message({
        //     message: '请填写担保期限（月）',
        //     type: 'warning'
        //   });
        //   return
        // }
        // if(that.loanAudit.LoanMoney!==0){
        //   if(!that.loanAudit.LoanMoney){
        //     this.$message({
        //       message: '请填写担保费(元)',
        //       type: 'warning'
        //     });
        //     return
        //   }
        // }
        // if(!that.loanAudit.LoanEndTime){
        //   this.$message({
        //     message: '请选择到期时间',
        //     type: 'warning'
        //   });
        //   return
        // }
        that.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            if(that.loanAudit.ProTypeName&&that.loanAudit.LoanMonth&&(that.loanAudit.LoanMoney===0||that.loanAudit.LoanMoney)){
              let flowParam = {
                Id:that.flowInfo.Id,
                Route:6,
                BankID:that.flowInfo.BankID,
                Type:that.flowInfo.Type
              }
              let loanAuditPara = utils.deepCopy(that.loanAudit);
              loanAuditPara.scoreList=that.scorelist.join(",");
              loanAuditPara.zxbgList=JSON.stringify(zblist);
              if(that.loanAudit.GuaranteeLetterTime && JSON.stringify(that.loanAudit.GuaranteeLetterTime) !== '{}'){
                if(!isNaN(Date.parse(that.loanAudit.GuaranteeLetterTime))){
                  that.loanAudit.GuaranteeLetterTime = new Date(that.loanAudit.GuaranteeLetterTime)
                }
                loanAuditPara.GuaranteeLetterTime = dateUtils.dateToStr("yyyy-MM-dd 00:00:00",that.loanAudit.GuaranteeLetterTime)
              }else{
                loanAuditPara.GuaranteeLetterTime = null;
              }
      
              if(that.loanAudit.LoanEndTime && JSON.stringify(that.loanAudit.LoanEndTime) !== '{}'){
                if(!isNaN(Date.parse(that.loanAudit.LoanEndTime))){
                  that.loanAudit.LoanEndTime = new Date(that.loanAudit.LoanEndTime)
                }
                loanAuditPara.LoanEndTime = dateUtils.dateToStr("yyyy-MM-dd 00:00:00",that.loanAudit.LoanEndTime)
              }else{
                loanAuditPara.LoanEndTime = null;
              }
      
              if(loanAuditPara.LoanMoney){
                loanAuditPara.LoanMoney = loanAuditPara.LoanMoney*100
              }
      
              that.loanCredit.keyword = that.loanApply.PersonCompanyKey
              that.loanCredit.num= that.loanApply.Money
              that.loanCredit.danwei= that.loanApply.PersonCompanyText
      
              that.loanCreditArea.keyword = that.flowInfo.IdCard
              that.loanCreditArea.name = that.flowInfo.Name
              var loanMortgage=that.loanMortgage;
              if(loanAuditPara.GuaranteeType==2){
                if(loanMortgage.length>0){
                    for(var i=loanMortgage.length-1;i>=0;i--){
                      if(loanMortgage[i].Type!=-1){
                        loanMortgage.splice(i,1)
                      }
                    }
                }
              }
              else if(loanAuditPara.GuaranteeType==4){
              if(loanMortgage.length>0){
                for(var i=loanMortgage.length-1;i>=0;i--){
                  if(loanMortgage[i].Type==-1){
                    loanMortgage.splice(i,1)
                  }
                }
               }
              }
              if(!this.businessShow) loanAuditPara.BusinessDetail="";
              loanAuditPara.ThirdBusiness=loanAuditPara.ThirdBusiness.join(",")
              let param = {
                loanAudit:that.setObjEmptyToNull(loanAuditPara),
                loanMortgage:that.loanMortgage,
                flowInfo:that.setObjEmptyToNull(flowParam),
                loanCredit:that.setObjEmptyToNull(that.loanCredit),
                loanCreditArea:that.setObjEmptyToNull(that.loanCreditArea)
              }
              // if(that.loanApply.Money){
              //   param.flowInfo.FinalMoney = that.loanApply.Money*1000000
              // }
              if(that.loanAudit.LoanMoney===0 || that.loanAudit.LoanMoney){
                param.flowInfo.GuaranteeFee = that.loanAudit.LoanMoney*100
              }
              
              that.saveFjFileInfo(function(flag){
                if(!flag){
                  this.$message.error("附件保存失败");
                }else{
                  flowapis.saveAuditInfo(param).then((res) => {
                    if(res){
                      if(that.myInterval){
                        clearInterval(that.myInterval)
                        that.myInterval = null
                      }
                      that.removeSaveItem()
                      that.onChangeClose()
                      // that.$emit('bankauditsucess');
                      that.$parent.bankAuditSucess();
                      // that.$message.success("提交成功");
                    }else{
                      that.$message.error("录入数据失败");
                    }
                  })
                }
              })
            }
          } else {
            return false;
          }
        });
        
      },

      /**
       * 退回
       */
      onRollBacklow(){
        let that = this
        this.$prompt('', '必须填写退回的原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '必须填写原因',
          inputValidator:(value)=>{
            if(value.trim().length<1){
              return false
            }
          },
          beforeClose: (action, instance, done)=>{
            if(action == 'confirm'){
                let value = instance.inputValue
                if(value && value != ''){
                  let flowParam = {
                    Id:that.flowInfo.Id,
                    Route:6,
                    BankID:that.flowInfo.BankID,
                    RecallReason:value,
                    RecallType:2,
                    State:2
                  }
                  let loanAuditPara = utils.deepCopy(that.loanAudit);
                  if(that.loanAudit.GuaranteeLetterTime && JSON.stringify(that.loanAudit.GuaranteeLetterTime) !== '{}'){
                    if(!isNaN(Date.parse(that.loanAudit.GuaranteeLetterTime))){
                      that.loanAudit.GuaranteeLetterTime = new Date(that.loanAudit.GuaranteeLetterTime)
                    }
                    loanAuditPara.GuaranteeLetterTime = dateUtils.dateToStr("yyyy-MM-dd 00:00:00",that.loanAudit.GuaranteeLetterTime)
                  }else{
                    loanAuditPara.GuaranteeLetterTime = null;
                  }

                  if(that.loanAudit.LoanEndTime && JSON.stringify(that.loanAudit.LoanEndTime) !== '{}'){
                    if(!isNaN(Date.parse(that.loanAudit.LoanEndTime))){
                      that.loanAudit.LoanEndTime = new Date(that.loanAudit.LoanEndTime)
                    }
                    loanAuditPara.LoanEndTime = dateUtils.dateToStr("yyyy-MM-dd 00:00:00",that.loanAudit.LoanEndTime)
                  }else{
                    loanAuditPara.LoanEndTime = null;
                  }

                  if(loanAuditPara.LoanMoney){
                    loanAuditPara.LoanMoney = loanAuditPara.LoanMoney*100
                  }

                  that.loanCredit.keyword = that.loanApply.PersonCompanyKey
                  that.loanCredit.num= that.loanApply.Money
                  that.loanCredit.danwei= that.loanApply.PersonCompanyText

                  that.loanCreditArea.keyword = that.loanApply.PersonCompanyKey
                  that.loanCreditArea.name = that.flowInfo.Name

                  let param = {
                    loanAudit:that.setObjEmptyToNull(loanAuditPara),
                    loanMortgage:that.loanMortgage,
                    flowInfo:that.setObjEmptyToNull(flowParam),
                    loanCredit:that.setObjEmptyToNull(that.loanCredit),
                    loanCreditArea:that.setObjEmptyToNull(that.loanCreditArea)
                  }
                  
                  flowapis.saveAuditInfo(param).then((res) => {
                    if(res){
                      done()
                    }else{
                      this.$message({
                        message: '退回失败请重试',
                        type: "error"
                      });
                    }
                  })
                }
            }else{
              done()
            }
          }
        }).then(({ value }) => {
          if(that.myInterval){
            window.clearTimeout(that.myInterval)
            that.myInterval = null
          }
          that.removeSaveItem()
          that.onChangeClose()
          that.$parent.bankAuditSucess();
        }).catch(() => {
               
        });
      },
      calcTableHeight(){
        this.$nextTick(() => {
          var height1=$(".content-box .content").height();
          var height=height1-50-20-40-20;
          this.scrollHeight = height;
        });
      },
      setDbInfo(){
        let that = this
        try{
          that.loanAudit.LoanMoney = Math.floor((((that.loanApply.Money*10000)*((that.loanAudit.GuaranteeRate*1.0)/100.0)*parseInt(that.loanAudit.LoanMonth))/12) * 100) / 100
          if(isNaN(that.loanAudit.LoanMoney)){
            that.loanAudit.LoanMoney = ''
          }
        }catch(e){
          that.loanAudit.GuaranteeRate = ''
          that.loanAudit.RiskSharing = null
          that.loanAudit.LoanMoney = null
        }
         
      },
      setDbInfo2(){
        let that = this
        for(let i=0;i<that.proTypeList.length;i++){
          if(that.proTypeList[i]["ProTypeName"]===that.loanAudit.ProTypeName){
            that.loanAudit.GuaranteeRate = that.proTypeList[i]['GuaranteeRate']
            that.loanAudit.RiskSharing = that.proTypeList[i]['RiskRate']
            try{
              that.loanAudit.LoanMoney = Math.floor((((that.loanApply.Money*10000)*((that.loanAudit.GuaranteeRate*1.0)/100.0)*parseInt(that.loanAudit.LoanMonth))/12) * 100) / 100
              if(isNaN(that.loanAudit.LoanMoney)){
                that.loanAudit.LoanMoney = ''
              }
            }catch(e){
              that.loanAudit.GuaranteeRate = ''
              that.loanAudit.RiskSharing = null
              that.loanAudit.LoanMoney = null
            }
            break
          }
        }
      },
      setEmptyApply(){
        let that = this
        that.loanApply = {
            ApplyID:'',
            UserId:'',
            Phone:'',
            PersonCompanyText:'',
            PersonCompanyFlag:'',
            PersonCompanyKey:'',
            LoanTipsId:'',
            Money:'',
            CreateTime:'',
            BankID:'',
            BankSiteID:'',
            SiteDirectorID:'',
            FirstBusiness:'',
            SecondBusiness:"",
            ThirdBusiness:[],
            PeopleCount:'',
            LastYearIncome:'',
            LastYearTax:'',
            LastYearProfit:'',
        }
      },
      setEmptyAudit(){
        let that = this
        that.loanAudit = {
          Id:null,
          Business:null,
          BusinessDetail:null,
          RiskSharing:null,
          LoanCode:null,
          LoanRate:null,
          State:null,
          LoanMonth:null,
          FristInquirer:null,
          SecondInquirer:null,
          Category:null,
          hknl_value3:null,
          CreditRating:null,
          TotalAssets:null,
          AssetCoverage:null,
          SaleProceeds:null,
          NetProfits:null,
          Ratal:null,
          LoanBalance:null,
          GuaranteeType:3,
          Guarantor:null,
          GuarantorCode:null,
          CustomProperty:null,
          CustomType:null,
          ReturnMoneyStatus:null,
          GuaranteeLetterTime:null,
          LoanEndTime:null,
          LoanMoney:null,
          EntrustedGuarantee:null,
          AccountManager:null,
          AccountManagerPhone:null,
          ProTypeName:null,
          Area:null,
          GuaranteeRate:null,
          WTDBHTH:null,
          YHDBHTH:null,
          xyzk_value5:null,
          xyzk_value4:null,
          xyzk_value3:null,
          xyzk_value2:null,
          xyzk_value1:null,
          hknl_value1:null,
          hknl_value2:null,
          dbcs_value1:null,
          dbcs_value2:1,
          hknl_value3:null,
        }
      },
      getEmptyMortgage(){
        let loanMortgagetemp = {
          Id:null,
          AuditID:null,
          Guarantor:null,
          GuarantorID:null,
          BdcName:null,
          BdcQzh:null,
          BdcArea:null,
          BdcMoney:null,
          BdcDyqzh:null,
          SbName:null,
          SbCount:null,
          SbType:null,
          SbMoney:null,
          SbDyqzh:null,
          SytName:null,
          SytQzh:null,
          SytArea:null,
          SytMoney:null,
          SytDyqzh:null,
          NccbtdName:null,
          NccbtdQzh:null,
          NccbtdArea:null,
          NccbtdMoney:null,
          NccbtdDyqzh:null,
          GqName:null,
          GqCount:null,
          GqMoney:null,
          GqDyzqh:null,
          OtherName:null,
          OtherCount:null,
          OtherGg:null,
          OtherMoney:null,
          OtherDyqzh:null,
          OtherBfwName:null,
          OtherBfwGg:null,
          OtherBfwMoney:null,
          OtherBfwDyqzh:null,
          Type:null
        }
        return loanMortgagetemp
      },
      setEmptyCredit(){
        let that = this
        that.loanCredit = {
            Id:null,
            keyword:null,
            num:null,
            createTime:null,
            danwei:null,
            money:null,
            comment2:null,
            comment2_gm:null,
            comment2_xy:null,
            comment2_js:null,
            comment:null,
            comment_xy:null,
            comment_gm:null,
            comment_js:null
        }
      },
      setEmptyCreditArea(){
        let that = this
        that.loanCreditArea = {
          Id:null,
          keyword:null,
          name:null,
          area:null,
        }
      },
      dynamicSaveItems(){
        let that = this
        let saveObj = {
          loanApply:that.loanApply,
          loanAudit:that.loanAudit,
          loanMortgage:that.loanMortgage,
          proTypeList:that.proTypeList,
          bankInfoObj:that.bankInfoObj,
          loanCredit:that.loanCredit,
          loanCreditArea:that.loanCreditArea,
          fileList:that.fileList,
          fileList_FJ:that.fileList_FJ,
          zxbglist:that.zxbglist,
        }
        if(that.flowInfo&&that.flowInfo.Id){
          // flowId_userId_type_router
          localStorage.setItem(that.flowInfo.Id+'_'+that.flowInfo.Type+'_'+5, JSON.stringify(saveObj))
        }
      },
      getSaveItems(name){
        let that = this
        let result = null
        let key = that.flowInfo.Id+'_'+that.flowInfo.Type+'_'+5
        if(localStorage.getItem(key)){
          let items = JSON.parse(localStorage.getItem(key))
          if(items){
            switch(name){
              case 'loanApply':
                if(items.loanApply){
                  result = items.loanApply
                }
                break;
                case 'loanAudit':
                  if(items.loanAudit){
                    result = items.loanAudit
                  }
                break;
                case 'loanMortgage':
                  if(items.loanMortgage){
                    result = items.loanMortgage
                  }
                break;
                case 'proTypeList':
                  if(items.proTypeList){
                    result = items.proTypeList
                  }
                break;
                case 'bankInfoObj':
                  if(items.bankInfoObj){
                    result = items.bankInfoObj
                  }
                break;
                case 'loanCredit':
                  if(items.loanCredit){
                    result = items.loanCredit
                  }
                break;
                case 'loanCreditArea':
                  if(items.loanCreditArea){
                    result = items.loanCreditArea
                  }
                break;
                case 'fileList':
                  if(items.fileList){
                    result = items.fileList
                  }
                break;
                case 'zxbglist':
                  if(items.zxbglist){
                    result = items.zxbglist
                  }
                break;
                case 'fileList_FJ':
                  if(items.fileList_FJ){
                    result = items.fileList_FJ
                  }
                break;
            }
          }
        }
        return result
      },
      timeOutSave(){
        let that = this
        if(that.myInterval){
            clearInterval(that.myInterval)
            that.myInterval = null
        }
        that.myInterval = window.setInterval(() => {
            setTimeout(() => {
              that.dynamicSaveItems()
            }, 1)
        }, 2000);
      },
      removeSaveItem(){
        let that = this
        let key = that.flowInfo.Id+'_'+that.flowInfo.Type+'_'+5
        localStorage.removeItem(key);
      },
      onFirstBusinessChooseConfirm(value){
        //变更二级分类的标题和placeholder
        this.changeSecondBusinessShow(value)
      },
      changeSecond(){
        var value=this.loanAudit.ThirdBusiness;
        for(var i=0;i<value.length;i++){
           if(value[i]=="其他"){
               this.businessShow=true;
               return
         }
         }
         this.businessShow=false;
       },
      changeSecondBusinessShow(value){
          switch (value) {
              case '电商':
                  this.secondBusinessTitle = '销售类目'
                  this.secondBusinessPlaceHolder = '如：生鲜、粮油'
                  break;
              case '种植':
                  this.secondBusinessTitle = '种植作物'
                  this.secondBusinessPlaceHolder = '如：水稻、棉花'
                  break;
              case '养殖':
                  this.secondBusinessTitle = '养殖种类'
                  this.secondBusinessPlaceHolder = '如：猪、肉牛'
                  break;
              case '农产品加工':
                  this.secondBusinessTitle = '加工品类'
                  this.secondBusinessPlaceHolder = '如：粮食加工、柑橘加工'
                  break;
              case '农资农机销售':
                  this.secondBusinessTitle = '销售品类'
                  this.secondBusinessPlaceHolder = '如：播种机、拖拉机、农资销售'
                  break;
              case '农产品购销':
                  this.secondBusinessTitle = '产品类型'
                  this.secondBusinessPlaceHolder = '如：柑橘、蔬菜'
                  break;
              case '农业服务':
                  this.secondBusinessTitle = '服务项目'
                  this.secondBusinessPlaceHolder = '如：收割、无人机植保'
                  break;
              case '农业旅游农家乐':
                  this.secondBusinessTitle = '产业类型'
                  this.secondBusinessPlaceHolder = '如：玫瑰园、果园、农家乐餐饮'
                  break;
              case '农业相关工程':
                  this.secondBusinessTitle = '工程内容'
                  this.secondBusinessPlaceHolder = '如：大棚、土壤改良、绿化工程'
                  break;
              case '其他':
                  this.secondBusinessTitle = '经营项目'
                  this.secondBusinessPlaceHolder = '请填经营项目'
                  break;
          }
      },
    },
  };
